import {Component, Input, OnInit} from '@angular/core';
import {LineInterface} from '../../../../lines/models/line.interface';
import {UpdateSelectedProcedure} from '../../../store/actions/selected-procedure.actions';
import {UpdateMission} from '../../../store/actions/mission.actions';
import {Store} from '@ngrx/store';

@Component({
    selector: 'app-cancel-sim-order',
    templateUrl: './cancel-sim-order.component.html',
    styleUrls: ['./cancel-sim-order.component.css'],
    standalone: false
})
export class CancelSimOrderComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.formSubmitted = false;
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(new UpdateMission({step: 1, phoneNumber: this.line.phoneNumber}, this.procedureCode));
    }
  }
}
